import { useState, useRef } from "react";
import { useDispatch } from "react-redux";
import * as yup from "yup";
import { useTranslation } from "react-i18next";

import { extractXMLDoc } from "../../utils/functions/xml";
import FormActions from "../../store/actions/FormActions";
import NotificationActions from "../../store/actions/NotificationActions";

const UploadXML = ({ onAction }) => {
  const [dragged, setDragged] = useState();

  const fileUrlInputRef = useRef();
  const inputRef = useRef();

  const dispatch = useDispatch();
  const { t } = useTranslation();

  const fileContentToForm = (file) => {
    dispatch(FormActions.setFileName(file.name));

    const fileReader = new FileReader();
    fileReader.readAsText(file, "UTF-8");
    fileReader.onload = (evt) => {
      let uploadedXML = evt.target.result;

      uploadedXML = uploadedXML.replaceAll("& ", "and ").trim();

      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(uploadedXML, "text/xml");

      let parsedFormValues;

      try {
        parsedFormValues = extractXMLDoc(xmlDoc);
        if (parsedFormValues) {
          dispatch(FormActions.uploadFileStart(parsedFormValues));
        }
      } catch (e) {
        dispatch(
          NotificationActions.addNotification("Failed to parse file", "error")
        );
      }
    };
  };

  const fileChangeHandler = (e) => {
    const file = e.target.files[0];
    if (file) {
      fileContentToForm(file);
      onAction && onAction();
    }
  };

  const uploadFileFromURLHandler = async (e) => {
    e.preventDefault();
    const fileURL = fileUrlInputRef.current.value;

    const urlSchema = yup.object({
      url: yup.string().url(),
    });

    try {
      const isValidUrl = await urlSchema.validate({
        url: fileURL,
      });

      dispatch(FormActions.uploadFileInitiated());
      const response = await fetch(`https://xml-podcast.herokuapp.com/xml`, {
        method: "POST",
        body: JSON.stringify({ link: fileURL }),
        headers: {
          "Content-Type": "application/json",
        },
      });

      let urlContent = await response.text();
      urlContent = urlContent.replaceAll("& ", "and ");

      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(urlContent, "text/xml");

      const parsedFormValues = extractXMLDoc(xmlDoc);
      if (parsedFormValues) {
        dispatch(FormActions.uploadFileStart(parsedFormValues));
        onAction && onAction();
      }
    } catch (e) {
      dispatch(
        NotificationActions.addNotification("Failed to parse file", "error")
      );
    }
  };

  const addDragStyles = (e) => {
    e.preventDefault();
    setDragged(true);
  };
  const dragEnterHandler = (e) => {
    e.preventDefault();
  };
  const removeDragStyles = () => {
    setDragged(false);
  };
  const dropFileHandler = (e) => {
    e.preventDefault();
    setDragged(false);

    const file = e.dataTransfer.files[0];
    if (file) {
      fileContentToForm(file);
      onAction && onAction();
    }
  };

  return (
    <>
      <div className="mb-3">
        <label htmlFor="upload-url" className="form-label">
          {t("uploadXML.inputLabel")}
        </label>
        <div className="row">
          <div className="col-8">
            <input
              type="text"
              className="form-control "
              id="upload-url"
              placeholder=""
              ref={fileUrlInputRef}
            />
          </div>
          <div className="col-4 d-grid gap-2 ps-1">
            <button
              type="button"
              className="btn btn-primary"
              id="upload-url-button"
              onClick={uploadFileFromURLHandler}
            >
              {t("uploadXML.submitButton")}
            </button>
          </div>
        </div>
      </div>
      <p className="text-center">{t("uploadXML.verticalSeparator")}</p>
      <div
        className={`file-drop-box ${dragged ? "dragged-over" : ""} text-center`}
        onDragOver={addDragStyles}
        onDragEnter={dragEnterHandler}
        onDragLeave={removeDragStyles}
        onDrop={dropFileHandler}
      >
        <input
          ref={inputRef}
          className="d-none"
          type="file"
          onChange={fileChangeHandler}
        />
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => {
            inputRef.current.value = null;
            inputRef.current.click();
          }}
          type="button"
        >
          {t("uploadXML.selectFileButton")}
        </button>
        <p className="m-0 mt-2">{t("uploadXML.dropText")}</p>
      </div>
    </>
  );
};

export default UploadXML;
